import React from 'react';
import CenterDiv from '../../../../components/UI/Containers/Center';
import { cn } from '../../../../utils';

export type TStatusChip =
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'INFO'
  | 'PENDING'
  | 'PURPLE';

const StatusChip = ({
  status = 'IN_PROGRESS',
  label,
  isShowDot = true,
  className,
  dotReplecement,
  onClick,
}: {
  status?: TStatusChip;
  label?: string;
  isShowDot?: boolean;
  className?: string;
  dotReplecement?: React.ReactNode;
  //
  onClick?: () => void;
}) => {
  const { bgColor, textColor, bgCircleColor } = useStatusChipColors(status);
  return (
    <CenterDiv
      onClick={onClick}
      className={cn(
        'text-xs font-bold rounded-full px-3 py-2 max-w-fit row items-center gap-1.5 h-fit',
        bgColor,
        textColor,
        className
      )}
    >
      {isShowDot &&
        (dotReplecement ?? (
          <div className={cn('w-2 h-2 rounded-full', bgCircleColor)} />
        ))}
      {label}
    </CenterDiv>
  );
};

export default StatusChip;

type TStatusStyles = { bgColor: string; textColor: string; bgCircleColor: string };

export const useStatusChipColors = (status: TStatusChip) => {
  const statusColorMap: Record<TStatusChip, TStatusStyles> = {
    IN_PROGRESS: {
      bgColor: 'bg-inProgressChipBg',
      textColor: 'text-inProgressChipText',
      bgCircleColor: 'bg-inProgressChipText',
    },
    COMPLETED: {
      bgColor: 'bg-successChipBg',
      textColor: 'text-successChipText',
      bgCircleColor: 'bg-successChipText',
    },
    CANCELLED: {
      bgColor: 'bg-redBg',
      textColor: 'text-redTextColor',
      bgCircleColor: 'bg-redTextColor',
    },
    INFO: {
      bgColor: 'bg-infoBg',
      textColor: 'text-infoText',
      bgCircleColor: 'bg-infoText',
    },
    PENDING: {
      bgColor: 'bg-summaryCardBg',
      textColor: 'text-tableHeaderText',
      bgCircleColor: 'bg-tableHeaderText',
    },
    PURPLE: {
      bgColor: 'bg-purpleBg',
      textColor: 'text-purpleText',
      bgCircleColor: 'bg-purpleText',
    },
  };

  return statusColorMap[status];
};
